import { Link } from 'react-router-dom';
import { nav, site } from '@/lib/marketing-content';
import { BrandLogo } from '@/components/brand-logo';
import { MarketingNavLink } from '@/components/marketing/site/marketing-nav-link';

const pageLinks = [
  { href: '/pricing', label: 'Pricing' },
  { href: '/solutions', label: 'Solutions' },
  { href: '/partners', label: 'Partners' },
  { href: '/about', label: 'About' },
  { href: '/contact', label: 'Contact' },
];

export function SiteFooter() {
  return (
    <footer className="py-3">
      <div className="shell">
        <div className="notch border-line bg-surface/20 flex flex-col items-center gap-6 border px-4 py-6 sm:gap-7 sm:px-6 sm:py-7 md:flex-row md:justify-between">
          <Link to="/" className="display flex items-center gap-3 text-lg tracking-[0.1em]">
            <BrandLogo variant="full" size="sm" />
          </Link>
          <nav className="flex flex-wrap justify-center gap-x-4 gap-y-2 sm:gap-x-6 sm:gap-y-3 xl:gap-x-8">
            {[...nav, ...pageLinks].map((item) => {
              const className =
                'readout text-muted hover:text-accent inline-flex min-h-10 items-center px-1 text-xs transition-colors sm:text-[0.65rem] xl:text-xs';

              if (item.href.includes('#')) {
                return (
                  <MarketingNavLink key={item.href} href={item.href} className={className}>
                    {item.label}
                  </MarketingNavLink>
                );
              }

              return (
                <Link key={item.href} to={item.href} className={className}>
                  {item.label}
                </Link>
              );
            })}
          </nav>
          <span className="readout text-faint">
            © {new Date().getFullYear()} {site.name}
          </span>
        </div>
      </div>
    </footer>
  );
}
